"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = pollAttrForType;

var _Enums = require("./Enums.json");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function pollAttrForType(type) {
  var _PollType$Image$PollT;

  return (_PollType$Image$PollT = {}, _defineProperty(_PollType$Image$PollT, _Enums.PollType.Image, 'images'), _defineProperty(_PollType$Image$PollT, _Enums.PollType.Piece, 'piece_ids'), _defineProperty(_PollType$Image$PollT, _Enums.PollType.Text, 'texts'), _PollType$Image$PollT)[type];
}